module.exports = __webpack_public_path__ + "img/ball2_xb.61bf3aaa.png";